import type { ID } from '@octopus-do/octopus-project-core'
import type { Workspace, WorkspaceItem } from '@store/reducers/dashboard/types'
import { useState } from 'react'

export const useFolders = (workspace: Workspace) => {
  const [renamingFolder, setRenamingFolder] = useState<ID | null>(null)

  const workspaceId = workspace.id

  const archive = workspace.folders.find(
    (f) => f.type === 'archive'
  ) as WorkspaceItem

  const dashboard = workspace.folders.find(
    (f) => f.type === 'dashboard'
  ) as WorkspaceItem

  const folders = workspace.folders.filter((f) => f.type === 'folder')

  const lastIdx = folders.length - 1

  const handleHideInput = () => {
    setRenamingFolder(null)
  }

  const handleShowInput = (id: ID) => {
    setRenamingFolder(id)
  }

  return {
    workspaceId,
    archive,
    dashboard,
    lastIdx,
    folders,
    renamingFolder,
    handleHideInput,
    handleShowInput,
  }
}
